<template>

  <v-switch v-model="val" :label="label"></v-switch>

</template>

<script>

export default {
  name: 'ToggleSwitch',
  props: ['value', 'label'],
  computed: {
    val: {
      get () {
        return this.value
      },
      set (v) {
        this.$emit('input', v)
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ToggleSwitch.vue